module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-content",
    class: {
      'with-side': _vm.$slots.side
    }
  }, [(_vm.$slots.side) ? _c('div', {
    staticClass: "rt-content__side",
    style: (_vm.sideStyle)
  }, [_vm._t("side")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rt-content__main",
    attrs: {
      "id": "contentMain"
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e1ee7bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/content/src/main.vue
// module id = 1403
// module chunks = 116